import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { VerandaShapeId, WindowShapeId } from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
    IFormInputType,
    IDimensionUnit,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import {
    allGlasses,
    allMetals,
    allPlastics,
    allSolidWoods,
    getMaterialsWithExceptions,
} from './common/materialGroups';
import additionalDataFactory from './common/fieldsAdditionalData';

const GlassGreenHouseForm: IForm = {
    formId       : PublishedFormId.GlassGreenHouse,
    type         : FormTypeId.GlassAndMirror,
    thumbnailURL : '/resized-images/forms/glassGreenHouse.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.ShapeDimension,
        IFormFieldKey.Material,
        IFormFieldKey.FrameMaterial,
        IFormFieldKey.Openings,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        shapeDimension: {
            shape: {
                value   : undefined,
                options : [
                    VerandaShapeId.FlatRoofVeranda,
                    VerandaShapeId.SlopingRoofVeranda,
                    VerandaShapeId.DoubleRoofVeranda,
                ],
                required: true,
            },
            dimension: {
                options: {
                    [VerandaShapeId.FlatRoofVeranda]: {
                        [FieldDimensionId.Length]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.HeightWall]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1800, max: 3000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 2,
                            range        : { min: 14, max: 30 },
                            required     : true,
                            defaultValue : 20,
                        },
                    },
                    [VerandaShapeId.SlopingRoofVeranda]: {
                        [FieldDimensionId.Length]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.HeightRoofTop]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1800, max: 3000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.HeightWall]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1800, max: 3000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 2,
                            range        : { min: 8, max: 20 },
                            required     : true,
                            defaultValue : 10,
                        },
                    },
                    [VerandaShapeId.DoubleRoofVeranda]: {
                        [FieldDimensionId.Length]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Width]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1500, max: 6000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.HeightRoofTop]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1800, max: 3000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.HeightWall]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 10,
                            range        : { min: 1800, max: 3000 },
                            required     : true,
                            defaultValue : 2000,
                        },
                        [FieldDimensionId.Thickness]: {
                            value        : undefined,
                            type         : IFormInputType.Range,
                            unit         : IDimensionUnit.Centimeters,
                            step         : 2,
                            range        : { min: 8, max: 20 },
                            required     : true,
                            defaultValue : 10,
                        },
                    },
                },
            },
        },
        material: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allGlasses,
                        ...allPlastics,
                    ],
                    [
                        MaterialId.PlexiglassFluorescent,
                        MaterialId.PlexiglassFrosted,
                        MaterialId.PlexiglassMirror,
                        MaterialId.PlexiglassTransparent,
                        MaterialId.PlexiglassWhite,
                        MaterialId.RecycledPlastic,
                        MaterialId.Pvc,
                        MaterialId.PvcRigid,
                    ],
                ),
                required: true,
            },
        },
        frameMaterial: {
            material: {
                value   : undefined,
                options : getMaterialsWithExceptions(
                    [
                        ...allSolidWoods,
                        ...allMetals,
                        ...allPlastics,
                    ],
                    [
                        MaterialId.BlackLocust,
                        MaterialId.Iroko,
                        MaterialId.Douglas,
                        MaterialId.Redcedar,
                        MaterialId.Larch,
                        MaterialId.Padouk,
                        MaterialId.Ipe,
                        MaterialId.Poplar,
                        MaterialId.DriftWood,
                        MaterialId.Garapa,
                        MaterialId.Rust,
                        MaterialId.Brass,
                        MaterialId.SheetMetal,
                        MaterialId.StainlessSteel,
                        MaterialId.Zinc,
                        MaterialId.PlexiglassFluorescent,
                        MaterialId.PlexiglassFrosted,
                        MaterialId.PlexiglassMirror,
                        MaterialId.PlexiglassTransparent,
                        MaterialId.PlexiglassWhite,
                        MaterialId.RecycledPlastic,
                    ],
                ),
                required: true,
            },
        },
        openings: {
            [WindowShapeId.SingleWindow]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
            [WindowShapeId.DoubleWindow]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
            [WindowShapeId.SlidingWindow]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
            [WindowShapeId.SimpleWindowDoor]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
            [WindowShapeId.DoubleWindowDoor]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
            [WindowShapeId.SlidingWindowDoor]: {
                value : undefined,
                min   : 0,
                max   : 4,
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 23000,
            budgetDefaultValue : 9500,
            budgetStep         : 500,
        }),
        contact: fieldsContact,
    },
};

export default GlassGreenHouseForm;
